import { render, staticRenderFns } from "./FormInspectionChecklist.vue?vue&type=template&id=6c61b49f&scoped=true&"
import script from "./FormInspectionChecklist.vue?vue&type=script&lang=js&"
export * from "./FormInspectionChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c61b49f",
  null
  
)

export default component.exports